import { SponsoredCardTranslationDto } from "@dtos/sponsored-card-translation.dto";
import { BaseConverter } from "./BaseConverter";
import { SponsoredCardTranslation } from "@models/sponsored-card-translation-model";
import { SponsoredCardConverter } from "./sponsoredCardConverter";

export class SponsoredCardTranslationConverter extends BaseConverter<SponsoredCardTranslation, SponsoredCardTranslationDto>{
    private sponsoredCardConverter = new SponsoredCardConverter()
    modelToDto(model: SponsoredCardTranslation): SponsoredCardTranslationDto {
        return new SponsoredCardTranslationDto(
            model.id,
            model.title,
            model.detail,
            model.distance,
            model.minPrice,
            model.maxPrice,
            model.currency,
            model.locale,
            model.sponsoredCard? this.sponsoredCardConverter.modelToDto(model.sponsoredCard) : undefined
        )
    }
    dtoToModel(dto: SponsoredCardTranslationDto): SponsoredCardTranslation {
        return new SponsoredCardTranslation(
            dto.id,
            dto.title,
            dto.detail,
            dto.distance,
            dto.minPrice,
            dto.maxPrice,
            dto.currency,
            dto.locale,
            dto.sponsoredCard? this.sponsoredCardConverter.dtoToModel(dto.sponsoredCard) : undefined
        )
    }
}